import { render, staticRenderFns } from "./RegisterHeaderMessage.vue?vue&type=template&id=0ed94078&scoped=true&"
import script from "./RegisterHeaderMessage.vue?vue&type=script&lang=js&"
export * from "./RegisterHeaderMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed94078",
  null
  
)

export default component.exports